import { BN } from "@project-serum/anchor";
import { SCALED_ONE, SECONDS_PER_DAY, SECONDS_PER_YEAR } from "./constants";
export function getPeriodicInterestRate(interestRate, interval) {
    return interestRate.mul(interval).div(SECONDS_PER_YEAR);
}
export function getInterest(principal, interestRate, interval) {
    const periodicRate = getPeriodicInterestRate(interestRate, interval);
    return principal.mul(periodicRate).div(SCALED_ONE);
}
export function getLateInterest(now, principal, nextPaymentTs, interestRate) {
    if (now.lte(nextPaymentTs)) {
        return new BN(0);
    }
    const daysLate = now
        .sub(nextPaymentTs)
        .subn(1)
        .div(SECONDS_PER_DAY)
        .addn(1)
        .mul(SECONDS_PER_DAY);
    return getInterest(principal, interestRate, daysLate);
}
export function getLateFee(now, nextPaymentTs, lateFeeRate, principal) {
    return now.gt(nextPaymentTs)
        ? lateFeeRate.mul(principal).div(SCALED_ONE)
        : new BN(0);
}
//# sourceMappingURL=utils.js.map